<template>
  <header class="app_header">
    <a :href="homeUrl"><img src="../assets/logo.svg"/></a>
    <div class="text_part">{{ app_name }} Application</div>
  </header>
</template>

<script>
export default {
  props: ["app_name", "product"],
  computed: {
    homeUrl() {
      return this.product === "dairy"
        ? "https://www.heartland.co.nz/rural-loans/dairy-direct"
        : "https://www.heartland.co.nz/rural-loans/sheep-beef-direct";
    },
  },
  data() {
    return {};
  },
};
</script>
